import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export default function parseConstraint(constraint) {
  var _constraint$split = constraint.split(' '),
      _constraint$split2 = _slicedToArray(_constraint$split, 2),
      constraintX = _constraint$split2[0],
      _constraint$split2$ = _constraint$split2[1],
      constraintY = _constraint$split2$ === void 0 ? constraintX : _constraint$split2$;

  return [constraintX, constraintY];
}